import React from 'react';
import {MapioContext, useMapioContextProvider} from '../../mapioContext';

export const MapioContextWrapper: React.FC = ({children}) => {
    const mapioContextValue = useMapioContextProvider();

    return <MapioContext.Provider value={mapioContextValue}>{children}</MapioContext.Provider>;
};
